export enum FirstAutomationCreationLocalStorageIds {
  ACCOUNT_HAS_FLOWS = 'acccount_has_flows',
}
